export default __webpack_public_path__ + "static/media/support.f095919b.webp";